import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import selectors from "selectors";
import {
  fetchPatientQuestionnaires,
  ignoreQuestionnaire
} from "actions/questionnaires";
import { fetchComplianceForms } from "actions/compliance-forms";
import { Page } from "components/ui";
import { useHistory } from "react-router-dom";
import useTranslate from "hooks/use-translate-language";
import useDocumentTitle from "hooks/use-document-title";
import { Button, Card, Breadcrumbs } from "components/ui_new";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import "./sign-questionnaire.scss";
import moment from "moment";

const Questionnaires = () => {
  const translate = useTranslate();
  const history = useHistory();
  const dispatch = useDispatch();
  const questionnaires = useSelector(selectors.getPatientQuestionnaires);
  const [complianceForms, setCompliancedForms] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  
  useDocumentTitle(translate("questionnaires"));

  useEffect(() => {
    setIsFetching(true);
    dispatch(fetchPatientQuestionnaires()).finally(() => {});

    dispatch(fetchComplianceForms())
      .then(data => {
        setCompliancedForms(data);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [dispatch]);

  const getActions = (ignore, route, questionnaireId) => {
    return (
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={event => {
            event.preventDefault();
            history.push(route);
          }}
          style={{ marginBottom: "10px" }}
          className="questionnaire-action-btn"
        >
          {translate("fillOutNow")}
        </Button>
        {ignore && (
          <Button
            variant="outlined"
            onClick={async () => {
              dispatch(ignoreQuestionnaire(questionnaireId));
            }}
            className="questionnaire-action-btn"
          >
            {translate("ignore")}
          </Button>
        )}
      </div>
    );
  };

  return (
    <Page.Container>
      <Page.Header title={translate("questionnaires")} goBack="/" />
      <Page.Content
        isFetching={isFetching}
        isEmpty={questionnaires.length === 0 && complianceForms.length === 0}
        emptyMessage={translate("noQuestionnaires")}
      >
        <Breadcrumbs
          childLabel="questionnaires"
          parentLink="questionnaires"
          parentLinkLabel="documents"
          title="questionnaires"
        />

        {questionnaires.map(q => (
          <Card
            key={q.questionnaire_assignment_id}
            actionsContainer={getActions(
              true,
              `/questionnaires/${q.questionnaire_assignment_id}`,
              q.questionnaire_assignment_id
            )}
          >
            <div className="questionnaire-container">
              <HelpOutlineIcon
                style={{ opacity: "56%", alignSelf: "center" }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="questionnaire-info">
                  <h2 className="questionnaire-title">{q.title} </h2>|{" "}
                  {q.description}
                </span>
                <span className="questionnaire-info">
                  {moment(q.questionnaire_date).format("LL")}
                </span>
              </div>
            </div>
          </Card>
        ))}

        {complianceForms.map(q => (
          <Card
            key={q.FormGUID}
            actionsContainer={getActions(
              false,
              `/fill-compliance-forms?form=${q.FormGUID}`,
              q.FormGUID
            )}
          >
            <div className="questionnaire-container">
              <HelpOutlineIcon
                style={{ opacity: "56%", alignSelf: "center" }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="questionnaire-info">
                  <h2 className="questionnaire-title">{q.Name} </h2>|{" "}
                  {q.Description}
                </span>
                <span className="questionnaire-info">
                  {moment(q.AssignedDate).format("LL")}
                </span>
              </div>
            </div>
          </Card>
        ))}
      </Page.Content>
    </Page.Container>
  );
};

export default Questionnaires;
